import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from "@angular/core";

import { Subscription } from "rxjs";
import { AccountService } from "projects/sepidz-web-framework/src/lib/services";

@Directive({
  selector: "[hasPermission]",
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private visible = false;
  private subscription: Subscription | null = null;

  @Input("hasPermission")
  permissions: string | boolean[] = [];

  // Note, if you don't place the * in front, you won't be able to inject the TemplateRef<any> or ViewContainerRef into your directive.
  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private accountService: AccountService) {}

  ngOnInit() {
    this.applyPermission();
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  private applyPermission() {
    let hasPermission = this.accountService.userHasPermission(`${this.permissions[0]}`, `${this.permissions[1]}`);
    if (typeof this.permissions[2] === "boolean") hasPermission = this.permissions[2] && hasPermission;
    if (hasPermission) {
      if (!this.visible) {
        this.viewContainer.createEmbeddedView(this.templateRef);
        this.visible = true;
      }
    } else {
      this.visible = false;
      this.viewContainer.clear();
    }
  }
}
